import React from 'react';
import BackgroundLeft from '../../BackgroundLeft';
import ForgotEmailForm from '../../../containers/ForgotPage/ForgotEmail/ForgotEmailForm';
import {
  LoginContainerWrap,
  LoginBlockRight,
} from '../../LoginPage/Login.style';
import { usePageTitle } from '@utils/hooks/usePageTitle';

const ForgotEmail = () => {
  usePageTitle('Forgot Email');
  return (
    <LoginContainerWrap role='main'>
      <BackgroundLeft type="password" />
      <LoginBlockRight>
        <ForgotEmailForm />
      </LoginBlockRight>
    </LoginContainerWrap>
  );
};

export default ForgotEmail;
